var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhoWe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-106"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M630.05,462.66a259.84,259.84,0,0,0-33.18-7.44c-50.91-7.81-168.25-10.53-225.12-8.12-73.83,3.12-307.81,55.41-325.48,7.58S33.79,56.41,68.1,49.13s156,21.36,227.74,23.44,243.33-25.52,314-28.64,77,8.32,93.59,69.67,34.31,263.09,31.19,309.88C732,463.26,656.48,470.33,630.05,462.66Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.05,462.66a259.84,259.84,0,0,0-33.18-7.44c-50.91-7.81-168.25-10.53-225.12-8.12-73.83,3.12-307.81,55.41-325.48,7.58S33.79,56.41,68.1,49.13s156,21.36,227.74,23.44,243.33-25.52,314-28.64,77,8.32,93.59,69.67,34.31,263.09,31.19,309.88C732,463.26,656.48,470.33,630.05,462.66Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--doors-2--inject-106"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "494.55 186.83 442.92 70.27 329.77 111.19 435.47 349.51 549.42 310.7 496.79 191.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "376.72 109.08 341.68 121.91 384.28 217.98 484.91 180.99 442.29 85.07 383.88 106.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "403.21 231.87 392.23 235.91 436.05 334.69 537.6 299.59 492.87 198.91 409.4 229.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485.5,
    cy: 190.89,
    r: 7.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485.5,
    cy: 190.89,
    r: 2.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "672.57 262.81 701.53 252.94 595.03 12.51 572.57 20.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "563.13 24.05 481.88 53.44 587.58 291.76 663.17 266.01",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "637.02 123.24 594.4 27.32 493.79 64.16 536.39 160.23 637.02 123.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "582.16 164.25 544.34 178.15 588.16 276.94 689.71 241.83 644.98 141.16 593.49 160.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 637.61,
    cy: 133.14,
    r: 7.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 637.61,
    cy: 133.14,
    r: 2.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "122.21 429.15 136.2 460.69 248.04 422.59 223.57 367.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "220.49 360.39 143.51 186.6 32.45 226.77 120.2 424.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "110.14 322.69 184.72 295.28 142.89 201.13 44.13 237.29 85.95 331.59 105.63 324.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.53 312.87 93.76 349.18 136.76 446.15 236.44 411.69 192.53 312.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.33,305a7,7,0,1,1-7-7A7,7,0,0,1,192.33,305Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.34,305a2,2,0,1,1-2-2A2,2,0,0,1,187.34,305Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-106"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.33,421.46s-5.18-36.25-34.18-41.43S602,401.78,597.89,403.85s-15.54-12.43-24.86-6.21-14.51,19.68-14.51,19.68-8.28-7.25-15.53-2.07-16.58,11.39-16.58,11.39-12.43-5.18-18.65-3.1-13.46,8.28-13.46,8.28H712.88s-5.18-14.5-16.58-19.68S671.44,426.64,668.33,421.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.71,166.93s-3.59-25.1-23.67-28.69-22.24,15.06-25.1,16.5-10.76-8.61-17.22-4.31-10,13.63-10,13.63-5.74-5-10.76-1.43-11.48,7.89-11.48,7.89-8.6-3.59-12.91-2.16-9.32,5.74-9.32,5.74H174.55s-3.59-10-11.48-13.63S145.86,170.52,143.71,166.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.68,75.29S668.21,51,648.78,47.53s-21.51,14.57-24.29,16-10.4-8.33-16.65-4.16-9.71,13.18-9.71,13.18-5.56-4.86-10.41-1.39-11.1,7.64-11.1,7.64-8.33-3.47-12.49-2.08-9,5.55-9,5.55H701.52S698.05,72.51,690.41,69,673.76,78.76,671.68,75.29Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.45,465.1s-3-21-19.81-24-18.61,12.61-21,13.81-9-7.2-14.41-3.6-8.4,11.41-8.4,11.41-4.81-4.21-9-1.2-9.6,6.6-9.6,6.6-7.21-3-10.81-1.8-7.81,4.8-7.81,4.8H329.27s-3-8.4-9.6-11.41S305.26,468.1,303.45,465.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.72,77s-3-21-19.81-24-18.62,12.61-21,13.81-9-7.2-14.41-3.6-8.41,11.41-8.41,11.41-4.8-4.21-9-1.2-9.61,6.6-9.61,6.6-7.2-3-10.81-1.8-7.8,4.8-7.8,4.8H235.54s-3-8.4-9.61-11.41S211.52,80,209.72,77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-106"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511,340.06c-.25-3.05-1-11-1-11l-44-6-1.14,2.33-3.12,8.28s-42.55,6.58-57,13.5a293.87,293.87,0,0,0,4.35,33.14c3.09,14.84,7.79,35.21,7.79,35.21l-2.57,1.84-.15,4s-4.56,6.29-8,9-6.11,3.52-5.05,4.7,5.55,1.41,10.77.26,11-4.22,11.82-4.59,4.27-1.56,4.27-1.56l-13.13,18.7-2.28.13-2.36,2.13a88.48,88.48,0,0,1-12.16-2.51c-5.51-1.66-6.49-1.82-6.11.51s5.15,8.39,10.54,12.29,10.86,7.32,10.86,7.32,1.76,1.54,3.35,1.05,5.49-8.9,5.49-8.9,4.23-4.33,6.26-6a51.59,51.59,0,0,0,6.15-6.78c2.19-2.66,18.72-16,24.36-27.41s8.12-18.78,10.73-20.86,31.09-30.08,35-34.21S511.28,343.12,511,340.06ZM445.17,396.6c-1.95,2.69-12.83,23-12.83,23s-1-4.69-.83-5.67-1.8-2.81-1.8-2.81l-1.53-48.76,34,4.33S447.13,393.9,445.17,396.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.15,188.47s-2.22-1.1-4.4-2.38-1.94.6-.53,2.12a48.86,48.86,0,0,0,5.72,4.44s-4.28-.88-3.89.1,3.65,2.45,7.69,2.56L450,188.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.24,208.83s-1.76-11.72-2.93-13.57-4.74-4.83-5.55-5.52-4.13-4-4.13-4a34.88,34.88,0,0,0-2.26-5.35c-1.41-2.63-2.54-1.34-2.39,1.08s2.17,7,2.17,7,2.64,4.12,3.06,6a40.38,40.38,0,0,1,.14,7,75.07,75.07,0,0,1-6.83-3.33c-2-1.26-3.23-.54-3,1.17s2.7,2.65,3.48,3.52,4.28,3.1,6.23,4.71a14.54,14.54,0,0,1,3.27,4.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.24,208.83s-6.37.62-8.31,2.32L453,212.86l2.22,5.53,10.19-3.67Z",
    style: {
      fill: "#31859B",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.94,212.6s-4.55.72-7.24,2.49-5.13,3.22-4.77,4.38,11.27,29,12.86,31.62,7.06,13.14,7.06,13.14l9.48-13.93Z",
    style: {
      fill: "#31859B",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.44,257.1s-1,1.65-3.13,13.44-1,28.34-.67,31.74-1.94,13.63-1.94,13.63-4.26,8.4-2.24,10.86,14,5,25,6.54,24.82-1.53,25.24-3.13-.28-5.66-.28-5.66-2.85-30.65-6-46.19-12.54-29.82-12.54-29.82Z",
    style: {
      fill: "#31859B",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.26 254.49 465.92 255.58 469.65 262.42 473.7 256.26 471.26 254.49",
    style: {
      fill: "#31859B",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.92 255.58 465.07 261.66 468.14 259.59 465.92 255.58",
    style: {
      fill: "#31859B",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.73,207.66s-10.27,3.57-11.12,5.64-1.45,3.67-2.24,4.38-8.65,1-8.45,2.86a21.88,21.88,0,0,0,1.27,4.62s-3.74,15.52-1.73,15.68a45.16,45.16,0,0,1,6.53,1.58l3.68,9.72,20.6-5.55.54-4.33a19.87,19.87,0,0,0,11.63-7.76c4.64-6.54,4.19-14.09-.67-20.66S494.34,207,494.34,207s1.1-3.55-1.93-3.71S482.19,203.51,484.73,207.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.34,207s1.1-3.55-1.93-3.71-10.22.19-7.68,4.34c0,0,7.8,3.15,7.56,4.64s-5.81,1.25-5.78,3.12,1.31,6.5.51,7.22-3.93,2.24-3.27,3.36a2.86,2.86,0,0,0,2.37,1.07s5.64-2.29,5.95,0-.95,5.79-2.66,6.87a9.56,9.56,0,0,1-3.44,1.3s-.76,2.59,2.27,4.79a11.09,11.09,0,0,0,5.57,2.27,19.87,19.87,0,0,0,11.63-7.76c4.64-6.54,4.19-14.09-.67-20.66S494.34,207,494.34,207Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.19,214.07a3.17,3.17,0,0,1,3.64,2.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.07,219.59c-.54.64-1.22.95-1.52.69s-.11-1,.43-1.62,1.22-.94,1.52-.69S475.61,219,475.07,219.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.57,228.68s3.73,1.07,5.63-.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486,235.2l-2.2-1.53a13,13,0,0,1-2.75,1.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "469.73 252.72 472.35 260.74 497.65 249.88 495.03 244.6 469.73 252.72",
    style: {
      fill: "#31859B",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.87,
    y: 269.15,
    width: 25.94,
    height: 3.89,
    rx: 1.81,
    transform: "translate(371.84 -250.44) rotate(50.26)",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.45,
    y: 260.55,
    width: 7.93,
    height: 3.38,
    transform: "translate(364.15 -251.77) rotate(50.26)",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.2,
    y: 273.47,
    width: 7.93,
    height: 3.38,
    transform: "translate(377.96 -255.37) rotate(50.26)",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.32,261.65h5.51a1.92,1.92,0,0,1,1.92,1.92V276a0,0,0,0,1,0,0H436.4a0,0,0,0,1,0,0V263.58A1.92,1.92,0,0,1,438.32,261.65Z",
    transform: "translate(365.85 -242.2) rotate(50.26)",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.67,275.3h5.51a1.92,1.92,0,0,1,1.92,1.92v12.44a0,0,0,0,1,0,0h-9.35a0,0,0,0,1,0,0V277.22A1.92,1.92,0,0,1,449.67,275.3Z",
    transform: "translate(380.44 -246) rotate(50.26)",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.57,
    y: 271.32,
    width: 4.48,
    height: 8.83,
    transform: "translate(373.22 -244.12) rotate(50.26)",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.15,
    y: 276.92,
    width: 8.19,
    height: 2.53,
    transform: "translate(373.82 -240.5) rotate(50.26)",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.39 294.63 412.67 280.53 432.69 269.72 438.67 276.92 424.39 294.63",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,294.69c-.65.54-3.76-2.15-7-6s-5.27-7.41-4.62-7.95,3.76,2.15,7,6S424.65,294.15,424,294.69Z",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.73 308.28 424.01 294.18 444.04 283.37 450.02 290.56 435.73 308.28",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.35,308.34c-.65.54-3.77-2.15-7-6s-5.27-7.41-4.63-7.95,3.77,2.15,7,6S436,307.8,435.35,308.34Z",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.97,
    y: 270.99,
    width: 8.19,
    height: 2.53,
    transform: "translate(371.73 -247.89) rotate(50.26)",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.31,296.45,469.15,294s-2.66,11.55-2.58,11.1,8.37,2.6,8.37,2.6Z",
    style: {
      fill: "#31859B",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.36,258.05s-5.53,4.09-4.31,10.51,10.2,30.2,10.2,30.2-15.14-3.86-16.17-3.12-3.94,11-2.14,12.09,20.09,7.85,29.25,9.36,12.67.41,13.35-1-6.9-30.86-8.22-36.69-4.39-17.56-7.5-20.8-5.15-3.73-8.12-3.16",
    style: {
      fill: "#31859B",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.25,298.76s9.79,1.3,12.82,3.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.72,299.44s3.45,2.09,3.58,4.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.15,294s-5.66-2.45-6.33-3-5-7.2-7.1-9.36-7.32-5.3-8.5-4.58,0,2,1.38,2.65a19.78,19.78,0,0,1,4.31,3.29,8.67,8.67,0,0,1,.72,2.09s-7.63-1.56-9.55-1.88-4.23-.08-4.4.95,0,.91.42,1.13a2.82,2.82,0,0,0,.3,2.78c1,1.23,4.9,2.47,6.55,3.5a16.69,16.69,0,0,1,3.5,3.61,23.7,23.7,0,0,1-4-.5c-1.6-.42-3.84-2.46-4.26-1.77s1.95,3.81,3.33,4.65a59.59,59.59,0,0,0,11.85,3.61c2.38.24,9.28,2.59,9.28,2.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.1,285.31s8.81,2.66,11.52,4.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.63,
    y1: 285.11,
    x2: 455.8,
    y2: 286.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--door-1--inject-106"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "186.45 163.98 186.45 164.27 186.34 164.02 186.45 163.98",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.8 405.63 287.57 405.72 263.06 347.2 287.8 405.63",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.43 363.22 292.84 403.68 292.83 403.68 302.36 304.67 229.32 147.15 286.32 124.79 397.43 363.22",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.36 304.67 297.74 306.24 224.79 148.93 188.7 71.1 193.33 69.53 229.32 147.15 302.36 304.67",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.83 403.68 292.73 404.77 288.1 406.33 287.88 405.6 288.18 405.48 292.83 403.68",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.88,405.6l-.08,0,.3.7.08-.85Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.79,148.93,188.7,71.1,186.45,164v.29L263.06,347.2l24.74,58.43.08,0,.3-.12,9.56-99.24Zm55,227-2.32-5.49L233,265.38l-37.38-88.26.32-16.86L197,101.51l1.91,4.11,21,45.23,19.74,42.57h0l.24.52,47.39,102.2Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.65,193.42h0l-1.53,16.5c-2.7,1.32-3.52,5.49-1.84,9.52a10.1,10.1,0,0,0,.81,1.57l-.94,10.11L233,265.38l-37.38-88.26.32-16.86L197,101.51l1.91,4.11,21,45.23Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.28 296.15 279.78 375.92 277.46 370.43 232.97 265.38 244.16 291.54 246.58 266.29 251.14 218.56 239.89 193.95 287.28 296.15",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.36 304.67 292.83 403.68 288.18 405.48 297.74 306.24 302.36 304.67",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.18 405.48 292.83 403.68 292.73 404.77 288.1 406.33 288.18 405.48",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.36 304.67 292.84 403.68 292.83 403.68 302.36 304.67",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.14,218.56l-4.56,47.73-2.42,25.25L233,265.38l3.18-34.25.94-10.11c1.93,3.2,5.11,4.9,7.64,3.89a4.58,4.58,0,0,0,2.59-2.94h0c1.79-1.27,2.27-4.37,1-7.37s-3.93-5-6.16-4.55h0a4.71,4.71,0,0,0-3.77-.24l-.28.13,1.53-16.5.24.52Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.32,222a9.66,9.66,0,0,0-.47-6.7,9.86,9.86,0,0,0-4.67-5.22c2.23-.4,4.88,1.5,6.16,4.55S249.11,220.69,247.32,222Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.85,215.26a9.86,9.86,0,0,0-4.67-5.22h0a4.71,4.71,0,0,0-3.77-.24l-.28.13c-2.7,1.32-3.52,5.49-1.84,9.52a10.1,10.1,0,0,0,.81,1.57c1.93,3.2,5.11,4.9,7.64,3.89a4.58,4.58,0,0,0,2.59-2.94h0A9.66,9.66,0,0,0,246.85,215.26Zm-5.63,5a1.53,1.53,0,0,1-.87,1.1c-.91.36-2.1-.4-2.64-1.71s-.25-2.66.66-3a1.42,1.42,0,0,1,1,0,3,3,0,0,1,1.59,1.68A3.21,3.21,0,0,1,241.22,220.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.22,220.23a1.53,1.53,0,0,1-.87,1.1c-.91.36-2.1-.4-2.64-1.71s-.25-2.66.66-3a1.42,1.42,0,0,1,1,0,3,3,0,0,1,1.59,1.68A3.21,3.21,0,0,1,241.22,220.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.16,353.23c15.65.52,29.23-9.88,42.63-18,42.69-25.88,99-30.93,142.94-7.29,15.4,8.28,28.73,21.33,31.19,39.41,1.39,10.13-1.44,21.06-8.62,28.35s-18.86,10.25-28.19,6.06c-4.24-1.9-8-5.34-9.32-9.78s.14-9.85,4.1-12.27c3.22-2,7.27-1.73,11-2.15s8-2.09,9-5.74a9.45,9.45,0,0,0-.2-4.6c-6-25.4-40.88-39.34-63.87-42.5-25.89-3.55-52.37,2.95-76,14.11-8.75,4.13-17.23,8.91-26.35,12.12s-19.15,4.78-28.49,2.27Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.21,156.81S268.75,137,262,120.58s-29.43-16.42-32.26-34,20.94-18.68,37.36-2.26,16.41,33.4,7.92,48.11S251.21,156.81,251.21,156.81Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.9,382.18s24-11.27,37.79-.14,7.49,32.87,23.53,40.51S397,407.7,385.89,387.33s-27.44-25.14-43.95-21.12S311.9,382.18,311.9,382.18Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.15,183s32.83-3.39,47.55-43S351,73.16,370.23,65.23c14.4-5.93,16.41,4.53,10.75,14.15-17.29,29.4-28,62.78-53.34,86.75C318.43,174.84,301.69,186.46,288.15,183Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.1,
    cy: 77.84,
    r: 11.04,
    transform: "translate(160.47 359.24) rotate(-76.5)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520.95,
    cy: 183.28,
    r: 11.04,
    transform: "translate(223.4 648.52) rotate(-76.78)",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.02,
    cy: 344.22,
    r: 11.04,
    transform: "translate(-78.77 588.78) rotate(-76.65)",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.27,
    cy: 276.04,
    r: 7.98,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.62,128.5a6.79,6.79,0,1,1-6.79-6.79A6.8,6.8,0,0,1,327.62,128.5Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 526.75,
    cy: 227.64,
    r: 6.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.45,141.49c3.94,2,14.61,14.51,18.6,19.29a1.06,1.06,0,0,1-.87,1.73c-6.21-.31-22.65-1.33-26.59-3.3s-14.94-14.66-19.06-19.51a1.06,1.06,0,0,1,.87-1.74C454.75,138.34,471.5,139.52,475.45,141.49Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.29,111.31c3-3.21,18.1-9.83,23.82-12.27a1.06,1.06,0,0,1,1.41,1.33c-2.09,5.86-7.78,21.31-10.81,24.52S454.37,135,448.55,137.53a1.06,1.06,0,0,1-1.42-1.34C449.32,130.23,455.27,114.52,458.29,111.31Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.45,120.85c1.63-4.1,13.22-15.8,17.64-20.17a1.06,1.06,0,0,1,1.8.72c.21,6.22.6,22.68-1,26.78S422.51,144.3,418,148.81a1.05,1.05,0,0,1-1.81-.72C416.06,141.74,415.82,125,417.45,120.85Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.25,170.43c-3.84-2.18-13.84-15.26-17.56-20.25a1,1,0,0,1,.95-1.68c6.19.64,22.55,2.52,26.39,4.7s14.14,15.43,18,20.48a1.06,1.06,0,0,1-1,1.7C455.75,174.66,439.08,172.6,435.25,170.43Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.86,142.24c.85-4.33,10.1-18,13.65-23.06a1.05,1.05,0,0,1,1.9.38c1.35,6.07,4.74,22.18,3.89,26.51s-10.16,18.3-13.74,23.56a1.06,1.06,0,0,1-1.91-.38C387.33,163,384,146.57,384.86,142.24Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.45,187.72c-4.18-1.44-16.4-12.47-21-16.68a1.06,1.06,0,0,1,.63-1.84c6.2-.5,22.63-1.65,26.8-.21s16.74,12.57,21.45,16.84a1.06,1.06,0,0,1-.63,1.84C432.37,188.12,415.62,189.15,411.45,187.72Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.88,176.94c-.18-4.4,5.64-19.81,7.9-25.6a1.05,1.05,0,0,1,1.93-.08c2.73,5.59,9.79,20.47,10,24.87s-5.62,20.17-7.88,26.11a1.05,1.05,0,0,1-1.94.08C358.13,196.58,351.06,181.35,350.88,176.94Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.33,215c-4.39-.43-18.85-8.3-24.28-11.33a1.06,1.06,0,0,1,.19-1.93c5.91-1.94,21.61-6.89,26-6.46s19.21,8.32,24.79,11.37a1.06,1.06,0,0,1-.19,1.94C407.78,210.48,391.72,215.39,387.33,215Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.13,201.31c-.18-4.41,5.63-19.82,7.89-25.61a1.06,1.06,0,0,1,1.94-.08c2.72,5.59,9.78,20.47,10,24.88s-5.61,20.16-7.87,26.11a1.06,1.06,0,0,1-1.94.08C327.37,220.94,320.31,205.71,320.13,201.31Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.58,239.33c-4.39-.43-18.85-8.3-24.28-11.33a1.06,1.06,0,0,1,.18-1.93c5.91-1.93,21.62-6.89,26-6.46s19.2,8.33,24.78,11.38a1.05,1.05,0,0,1-.18,1.93C377,234.84,361,239.76,356.58,239.33Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.26,235.76s28.25-1.85,52.14-22C366.72,200,377.46,181.07,393,166.58c24.84-23.15,62-37,95.89-29.88",
    style: {
      fill: "none",
      stroke: "#31859B",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.25,130.07c4.37.61,18.47,9.12,23.76,12.39a1.06,1.06,0,0,1-.27,1.92c-6,1.67-21.9,5.92-26.27,5.3s-18.81-9.16-24.26-12.45a1.06,1.06,0,0,1,.28-1.93C492.63,133.65,508.88,129.45,513.25,130.07Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.66,284.91c-1.1-8.73-15.28-7.64-15.28-7.64s7.64-9.83,2.18-15.28-11.46,7.64-11.46,7.64,2.18-14.19-4.37-20.74-13.64-1.64-9.82,10.37,0,13.1,0,13.1l-.12.24a39,39,0,0,1,.48,13.12s6-13.09,11.46-7.64-2.18,15.28-2.18,15.28,14.18-1.09,15.27,7.64c.52,4.17-2.43,6-5.66,6.72,8.95,2.88,17.42,7.85,17.86-.44.54-10.37-11.46-15.28-11.46-15.28S342.75,293.64,341.66,284.91Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,255.8s-5.38-17.55-1.79-19.7,8.95.36,9.66,6.45S320,255.8,320,255.8Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.6,295s-1.81-13.77,1.13-14.92,6.63,1.38,6.4,6S306.6,295,306.6,295Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.19,271.71s13.58-12.34,17.05-10,3.49,8.26-1.71,11.5S332.19,271.71,332.19,271.71Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.74,295.28s18.32-1.09,19.56,2.89-2.45,8.62-8.54,7.89S339.74,295.28,339.74,295.28Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.21,297.07S321.53,296,322.77,300s-2.45,8.62-8.54,7.89S303.21,297.07,303.21,297.07Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,170.07s-11.67-26.25,21.15-52.5S344.62,57.76,323.47,41s-43,0-45.22-11.67,39.38-24.79,62.72,0,13.13,52.51-7.29,70S276.06,135.8,279,170.07Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.26,285.78s37.73,3,49.57,25.89,24.41,14.06,27.37,8.14c8.56-17.12-13.78-26.28-26.46-30.05a146.65,146.65,0,0,0-27.88-5.25C530.23,283.79,522.36,286.34,515.26,285.78Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.22,102.7s20.29-31.94,9.07-55.17,3.43-28,9.94-26.77c18.54,3.38,12.13,27.93,8,40a132.35,132.35,0,0,1-10.87,23.79C407.13,91.69,399.35,96.19,395.22,102.7Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoWe);
export default __webpack_public_path__ + "static/media/who-we.5d50a6aa297b5054bd2ea27fca86b0c5.svg";
export { ForwardRef as ReactComponent };